<div class="role-users__container">
  <app-search-bar
    [placeholder]="searchPeople()"
    [query]="store.searchQuery()"
    (queryChange)="store.setSearchQuery($event)"
    [clearSearch]="store.clearSearch"
    class="role-users__search-bar"
  ></app-search-bar>

  <mat-chip-listbox
    aria-label="User assignment filter"
    [value]="store.userFilter()"
    (change)="store.setUserFilter($event.value)"
  >
    <mat-chip-option value="all">{{ all() }}</mat-chip-option>
    <mat-chip-option value="assigned">{{ assigned() }}</mat-chip-option>
    <mat-chip-option value="notAssigned">{{ notAssigned() }}</mat-chip-option>
  </mat-chip-listbox>

  @let assignedUser = store.filteredAssignedUsers(); @let unassignedUser =
  store.filteredUnassignedUsers(); @if (assignedUser.length === 0 &&
  unassignedUser.length === 0) {
  <app-empty-search [clearSearch]="store.clearSearch"></app-empty-search>
  } @else {
  <div class="role-users__assignment">
    @if (assignedUser.length > 0) {
    <div class="role-users__assignment-assigned-users">
      <ng-container
        *ngTemplateOutlet="
          assignmentHeader;
          context: { $implicit: 'group', label: assignedUsers() }
        "
      ></ng-container>
      <mat-list class="role-users__users-list">
        @for (user of assignedUser; track user) {
        <ng-container
          *ngTemplateOutlet="
            userListItem;
            context: { $implicit: user, isAssigned: true }
          "
        ></ng-container>
        }
      </mat-list>
    </div>
    } @if (unassignedUser.length > 0) {
    <div class="role-users__assignment-not-assigned-users">
      <ng-container
        *ngTemplateOutlet="
          assignmentHeader;
          context: { $implicit: 'groups', label: notAssignedUsers() }
        "
      ></ng-container>
      <mat-list class="role-users__users-list">
        @for (user of unassignedUser; track user) {
        <ng-container
          *ngTemplateOutlet="
            userListItem;
            context: { $implicit: user, isAssigned: false }
          "
        ></ng-container>
        }
      </mat-list>
    </div>
    }
  </div>
  }
</div>

<ng-template #assignmentHeader let-iconName let-label="label">
  <div class="assignment-header">
    <mat-icon class="assignment-icon">{{ iconName }}</mat-icon>
    <span class="assignment-label">{{ label }}</span>
  </div>
</ng-template>

<ng-template #userListItem let-user let-isAssigned="isAssigned">
  <mat-list-item class="user-list-item">
    <div class="user-item">
      <app-user-info
        [userName]="user?.fullName ?? ''"
        [userEmail]="user?.email ?? ''"
        [class.user-info-grid]="!isAssigned"
        [searchQuery]="store.searchQuery()"
      ></app-user-info>

      @if (!isAssigned) {
      <app-role-info
        [role]="user?.userRole"
        [noBackground]="true"
        class="role-info role-info-grid"
      ></app-role-info>
      <span
        [matTooltip]="chooseRoleNameFirst()"
        [matTooltipDisabled]="!addDisabled()"
        [matTooltipShowDelay]="200"
        class="add-user-button"
      >
        <button
          mat-button
          type="button"
          (click)="store.addUserToRole(user)"
          [disabled]="addDisabled()"
          class="dark-text-button"
        >
          <mat-icon>person_add</mat-icon>
          {{ add() }}
        </button>
      </span>
      } @else {
      <app-role-info
        [role]="store.tempRole()!"
        [roleName]="roleName()"
        [roleSelected]="true"
        [icon]="icon()!"
        class="role-info role-info-grid-assigned"
      ></app-role-info>
      }
    </div>
  </mat-list-item>
</ng-template>
